import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockCards {
    static init() {
        this.blocks = document.querySelectorAll(".block-cards");
        if (!this.blocks.length) {
            return;
        }

        this.build(this.blocks);
    }

    static build(blocks) {

        blocks.forEach(block => {
            const cards = block.querySelectorAll('.card-item');
            gsap.set(cards, {autoAlpha: 0, y: 100});

            this.tl1 = gsap.timeline({
                scrollTrigger: {
                    trigger: block,
                    start: "top bottom",
                    end: "top 20%",
                    scrub: true,
                    invalidateOnRefresh: true,
                    overwrite: true,
                }
            });

            this.tl1.to(cards, {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                stagger: 0.5,
            });

            // ScrollTrigger.batch(cards, {
            //     interval: 0.1,
            //     batchMax: 3,
            //     start: "top 95%",
            //     end: "top center",
            //     scrub: true,
            //     onEnter: batch => {
            //         gsap.to(batch, {
            //             autoAlpha: 1,
            //             y: 0,
            //             stagger: {each: 0.15, grid: [1, 3]},
            //             overwrite: true,
            //             duration;:
            //     });
            //     },
            //     onLeaveBack: batch => {
            //         gsap.to(batch, {
            //             autoAlpha: 0,
            //             y: 100,
            //             stagger: {each: 0.15, grid: [1, 3]},
            //             overwrite: true,
            //         });
            //     }
            // });

        });

    }
}